import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-collect-star",
  "use": "icon-collect-star-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-collect-star\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<polygon points=\"11.92 15.45 8.18 17.37 9.07 13.39 6 10.57 10.23 10.16 12.07 6.5 13.79 10.23 18 10.78 14.83 13.49 15.59 17.5 11.92 15.45\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol